export default "__VITE_ASSET__CLUi6Anb__"